// Researcher / University Evidence — reuses the School Evidence page.
// Header/Footer auto-detect the `/researcher/*` path so Researcher nav & branding are applied.
import SchoolEvidence from '../school/SchoolEvidence';

export default SchoolEvidence;
